export default "__VITE_ASSET__BuiNzajp__"